import React from 'react';
import './style.scss';
import { Form, InputGroup } from 'react-bootstrap';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DoneIcon from '@mui/icons-material/Done';

interface Props {
    id: string
    value?: string | number | undefined
    onChange? : React.ChangeEventHandler<HTMLInputElement> | undefined
    placeholder: string
    disabled?: boolean | undefined
    readOnly?: boolean | undefined
    type?: React.HTMLInputTypeAttribute
    onBlur? : React.FocusEventHandler<HTMLInputElement> | undefined
    maxLength? : number
    className?: string | undefined,
    label?: string | undefined,
    isInvalid?: boolean | undefined,
    errorMsg?: string,
    validation?: boolean | undefined,
    defaultValue?: string | number | readonly string[] | undefined;
    as?: ('textarea' & React.ElementType) | undefined;
    rows?: number
  }

const Default: React.FC<Props> = (props) => {
  const {
    value, onChange, placeholder, readOnly,
    label, className, errorMsg, disabled,
    id, onBlur, maxLength, validation, isInvalid,
    defaultValue, type = 'text', as, rows,
  } = props;

  const renderIcon = () => {
    if (isInvalid) return 'warning-icon';
    if (value) return 'success-icon';
    return 'd-none';
  };

  return (
    <Form.Group className={`form-default-container ${className ?? ''}`}>
      <Form.Label htmlFor={id} className={label ? 'label' : 'd-none'}>{label}</Form.Label>
      <InputGroup className="position-relative">
        {validation && as !== 'textarea' && (
          <div className={renderIcon()}>
            {isInvalid ? <WarningAmberIcon fontSize="small" /> : <DoneIcon fontSize="small" />}
          </div>
        )}
        <Form.Control
          as={as}
          rows={rows}
          id={id}
          type={type}
          disabled={disabled}
          isInvalid={isInvalid}
          className={as === 'textarea' ? 'textarea-input' : 'input rounded-pill'}
          maxLength={maxLength}
          onBlur={onBlur}
          value={value}
          placeholder={placeholder}
          readOnly={readOnly}
          onChange={onChange}
          defaultValue={defaultValue}
          name={id}
          style={validation && as !== 'textarea' ? { paddingRight: 20 } : {}}
        />
        <Form.Control.Feedback
          type="invalid"
          className="invalidMsg"
        >
          {errorMsg}
        </Form.Control.Feedback>
      </InputGroup>
    </Form.Group>
  );
};

export default React.memo(Default);
